import React from 'react'
import './paragraph.scss';

function Paragraph({ data }) {
    const { scategory, label, content } = data;
    return (
        <div className="paragraph-container">
            <div>
                {label && <h4 className='paragraph-category'>{label}</h4>}
                {content.headerH2 && <div className='paragraph-title'>{content?.headerH2}</div>}
                <div className= 'paragraph-content-wrapper'>
                {content.paraText && <p className='paragraph-text m-0' dangerouslySetInnerHTML={{ __html: content.paraText }} />}
                    {scategory === "single" ? (
                        <p key={content.data} className='paragraph-text' dangerouslySetInnerHTML={{ __html: content.data }} />
                    ) : (
                        content.data && Array.isArray(content.data) && content.data.map((txt, i) =>
                        (<>
                            {content.subTitle && content.subTitle[i] && <h4 className='paragraph-subtitle'>{content?.subTitle[i]}</h4>}
                            <p key={i} className='paragraph-text' dangerouslySetInnerHTML={{ __html: txt }} />
                        </>)
                        )
                    )}
                    {content.headerH3 && <div className='paragraph-title'>{content?.headerH3}</div>}
                    {content.ol && Array.isArray(content.ol) && (
                        <ol className={ !content.number ? 'custom-dash' : '' }>
                            {content.ol.map((item) => (
                                <li key={item} className='paragraph-text' dangerouslySetInnerHTML={{ __html: item }}></li>
                            ))}
                        </ol>
                    )}
    
                    {content.data1 && Array.isArray(content.data1) && content.data1.map((txt, i) =>
                    (<>
                        {content.subTitle && content.subTitle[i] && <h4 className='paragraph-subtitle'>{content?.subTitle[i]}</h4>}
                        <p key={i} className='paragraph-text' dangerouslySetInnerHTML={{ __html: txt }} />
                    </>)
                    )}
                    {content.ol1 && Array.isArray(content.ol1) && (
                        <ol className={ !content.number ? 'custom-dash' : '' }>
                            {content.ol1.map((item) => (
                                <li key={item} className='paragraph-text' dangerouslySetInnerHTML={{ __html: item }}></li>
                            ))}
                        </ol>
                    )}
                    
                </div>
            </div>
        </div>
    )
}
export default React.memo(Paragraph);